import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'formatQuantidade',
})
export class FormatQuantidadePipe implements PipeTransform {
  private numberFormatter = new Intl.NumberFormat('pt-BR', {
    style: 'decimal',
    currency: 'BRL',
  });

  transform(quantidade: number): string {
    return this.numberFormatter.format(quantidade);
  }
}
